module.exports = __webpack_public_path__ + "static/portfolio-songthai-ce70ff6eea147b4c11ff65d2e8f68f68.jpg";